<template lang="pug">
#dashboard
  v-toolbar(elevation="2" height="88")
    v-toolbar-title.text-h4.font-weight-bold {{$t('Dashboard.__Dashboard')}}
    v-spacer
    v-menu(open-on-hover offset-y)
      template(v-slot:activator="{ on }")
        v-btn(rounded v-on="on" color="primary")  
          | {{$t('Dashboard.__AddItem')}}
          v-icon(right dark) keyboard_arrow_down
      v-list
        v-list-item(v-for="item in actionItems" :key="item.title" :to="'/'+$i18n.locale+item.to" :disabled="item.disabled")
          v-list-item-title {{item.title}}
  v-container
    Alert
    v-row
      v-col.pt-0(cols="12" md="6")
        v-card
          v-card-title {{$t('Dashboard.__Shortcuts')}}
          v-card-text
            v-row
              v-col.py-2
                .sutitle.d-flex.mb-2
                  .text-subtitle-2.mr-3 {{$t('Dashboard.__GoTo')}}
                v-row
                  v-col.py-0(cols="12" md="6" v-for="item in shortcutItems" :key="item.title")
                    li.py-1
                      router-link.text-subtitle-2.primary--text(:to="(item.disabled)?'':('/'+$i18n.locale+item.to)" :disabled="item.disabled" style="text-decoration: none;") {{item.title}}
      v-col.pt-0(cols="12" md="6")
        v-card
          v-card-title {{$t('Dashboard.__OverdueInvoiceAndBills')}}
          v-card-text
            v-row
              v-col(cols="12" md="6").py-2
                .sutitle.d-flex.mb-2
                  .text-subtitle-2.mr-3 {{$t('Dashboard.__OverdueInvoice')}}
                  router-link(:to="'/'+$i18n.locale+'/invoices'" style="text-decoration: none;")
                    //-invoices
                    .text-subtitle-2.primary--text …{{$t('Dashboard.__AllInvoices')}}
                li.py-1(v-for="item in overdueInvoices")
                  router-link.text-subtitle-2.primary--text(:to="'/'+$i18n.locale+'/invoices/'+item.id" style="text-decoration: none;") {{item.name}}
                  //-'/invoices/'+item.id
                  span , {{getAmountWithCurrency(item.amount, currencyCode)}}
              v-col(cols="12" md="6").py-2
                .sutitle.d-flex.mb-2
                  .text-subtitle-2.mr-3 {{$t('Dashboard.__OverdueBills')}}
                  router-link(:to="'/'+$i18n.locale+'/bills'" style="text-decoration: none;")
                    //-/bills
                    .text-subtitle-2.primary--text …{{$t('Dashboard.__AllBills')}}
                li.py-1(v-for="item in overdueBills")
                  router-link.text-subtitle-2.primary--text(:to="'/'+$i18n.locale+'/bills/edit/'+ item.id" style="text-decoration: none;") {{item.name}}
                  //-'/bills/'+item.id
                  span , {{getAmountWithCurrency(item.amount, currencyCode)}}


      v-col(cols="12")
        v-card
          v-card-title {{$t('Dashboard.__SummaryOfInvoiceAndBills')}}
          v-card-text
            v-row
              v-col(cols="12" md="6")
                bar-chart(:chartdata="invoiceAndBillChartdata" :options="invoiceAndBillOptions") 
              v-col(cols="12" md="3")
                .sutitle.d-flex.mb-2
                  .text-subtitle-2.mr-3 {{$t('EstimatesAndInvoices.__Invoice')}}
                v-simple-table(dense)
                  template(v-slot:default)
                    thead
                      tr
                        th.text-left 
                        th.text-right {{$t('Dashboard.__NumberOf')}}
                        th.text-right {{$t('Dashboard.__Total')}}
                    tbody
                      tr(v-for="item in invoicesTotalArray" :key="item.key")
                        td {{item.key}}
                        td.text-right {{item.cnt}}
                        td.text-right {{getAmountWithCurrency(item.total, currencyCode)}}
              v-col(cols="12" md="3")
                .sutitle.d-flex.mb-2
                  .text-subtitle-2.mr-3 {{$t('Bills.__Bill')}}
                v-simple-table(dense)
                  template(v-slot:default)
                    thead
                      tr
                        th.text-left 
                        th.text-right {{$t('Dashboard.__NumberOf')}}
                        th.text-right {{$t('Dashboard.__Total')}}
                    tbody
                      tr(v-for="item in billsTotalArray" :key="item.key")
                        td {{item.key}}
                        td.text-right {{item.cnt}}
                        td.text-right {{getAmountWithCurrency(item.total, currencyCode)}}




      v-col(cols="12" md="6")
        v-card
          v-card-title
            span.title {{$t('Dashboard.__CashFlow')}}
            span.d-flex.ml-4.subtitle
              a(:class="cashFlowChartMode=='month12'?'font-weight-bold black--text':''" @click="cashFlowChartMode='month12'") {{$t('Dashboard.__Last12Months')}}
              .seperate.mx-2 /
              a(:class="cashFlowChartMode=='month24'?'font-weight-bold black--text':''" @click="cashFlowChartMode='month24'") {{$t('Dashboard.__Last24Months')}}
          v-card-text
            bar-chart(:chartdata="cashFlowChartData" :options="cashFlowChartOptions") 

      v-col(cols="12" md="6")
        v-card
          v-card-title
            span.title {{$t('Dashboard.__ProfitLoss')}}
            span.d-flex.ml-4.subtitle
              a(:class="incomeStatementsChartMode=='month12'?'font-weight-bold black--text':''" @click="incomeStatementsChartMode='month12'") {{$t('Dashboard.__Last12Months')}}
              .seperate.mx-2 /
              a(:class="incomeStatementsChartMode=='month24'?'font-weight-bold black--text':''" @click="incomeStatementsChartMode='month24'") {{$t('Dashboard.__Last24Months')}}
          v-card-text
            bar-chart(:chartdata="incomeStatementsChartData" :options="incomeStatementsChartOptions") 

      v-col(cols="12" md="6")
        v-card
          v-card-title {{$t('Dashboard.__AgedReceivablesAndPayables')}}
          v-card-text
            v-row
              v-col(cols="12" md="6" v-if="agedReceivablesData").py-0 
                v-simple-table.report-table(dense)
                  template(v-slot:default)
                    thead
                      tr
                        th {{$t("Reports.__AgedReceivables")}}
                        th
                    tbody
                      tr
                        td.primary--text {{$t("Reports.__NotYetOverdue")}}
                        td.text-right {{getAmountWithCurrency(agedReceivablesData['NotYetOverdue'].amount, currencyCode)}}
                      tr
                        td {{$t("Reports.__30orLess")}}
                        td.text-right {{getAmountWithCurrency(agedReceivablesData['30OrLess'].amount, currencyCode)}}
                      tr
                        td {{$t("Reports.__31to60")}}
                        td.text-right {{getAmountWithCurrency(agedReceivablesData['31To60'].amount, currencyCode)}}
                      tr
                        td {{$t("Reports.__61to90")}}
                        td.text-right {{getAmountWithCurrency(agedReceivablesData['61To90'].amount, currencyCode)}}
                      tr
                        td {{$t("Reports.__91orMore")}}
                        td.text-right {{getAmountWithCurrency(agedReceivablesData['91OrMore'].amount, currencyCode)}}

              v-col(cols="12" md="6" v-if="agedPayablesData").py-0
                v-simple-table.report-table(dense)
                  template(v-slot:default)
                    thead
                      tr
                        th {{$t("Reports.__AgedReceivables")}}
                        th
                    tbody
                      tr
                        td.primary--text {{$t("Reports.__NotYetOverdue")}}
                        td.text-right {{getAmountWithCurrency(agedPayablesData['NotYetOverdue'].amount, currencyCode)}}
                      tr
                        td {{$t("Reports.__30orLess")}}
                        td.text-right {{getAmountWithCurrency(agedPayablesData['30OrLess'].amount, currencyCode)}}
                      tr
                        td {{$t("Reports.__31to60")}}
                        td.text-right {{getAmountWithCurrency(agedPayablesData['31To60'].amount, currencyCode)}}
                      tr
                        td {{$t("Reports.__61to90")}}
                        td.text-right {{getAmountWithCurrency(agedPayablesData['61To90'].amount, currencyCode)}}
                      tr
                        td {{$t("Reports.__91orMore")}}
                        td.text-right {{getAmountWithCurrency(agedPayablesData['91OrMore'].amount, currencyCode)}}
      v-col(cols="12" md="6")
        v-card
          v-card-title {{$t('Dashboard.__YearIncome')}}
          v-card-text
            v-simple-table.report-table(dense)
              thead
                tr
                  th {{$t("Dashboard.__ExpenseAccount")}}
                  th.text-right(v-for="item in incomeTableRawData") {{item.year}} 
              tbody
                tr
                  td {{$t("Dashboard.__Income")}}
                  td.text-right(v-for="item in incomeTableRawData")  {{getAmountWithCurrency(item.incomesBalance, currencyCode)}}
                tr
                  td {{$t("Dashboard.__Cost")}}
                  td.text-right(v-for="item in incomeTableRawData")  {{getAmountWithCurrency(item.costsBalance, currencyCode)}}
                tr
                  td {{$t("Dashboard.__Expense")}}
                  td.text-right(v-for="item in incomeTableRawData")  {{getAmountWithCurrency(item.expensesBalance, currencyCode)}}
                tr
                  td {{$t("Dashboard.__NetIncome")}}
                  td.text-right(v-for="item in incomeTableRawData")  {{getAmountWithCurrency(item.netBalance, currencyCode)}}

      v-col(cols="12" md="12")
        v-card
          v-card-title 
            span.title {{$t('Dashboard.__ExpensesAnalysis')}}
            span.d-flex.ml-4.subtitle
              a(:class="costsAndExpensesChartMode=='month'?'font-weight-bold black--text':''" @click="costsAndExpensesChartMode='month'") {{$t('Dashboard.__ThisMonth')}}
              .seperate.mx-2 /
              a(:class="costsAndExpensesChartMode=='year'?'font-weight-bold black--text' :''" @click="costsAndExpensesChartMode='year'") {{$t('Dashboard.__ThisYear')}}
          v-card-text
            v-row
              v-col(cols="12" md="6")
                pie-chart(v-if="costsAndExpensesChartData.labels.length!=0" :chartdata="costsAndExpensesChartData" :options="costsAndExpensesChartOptions") 
                .title(v-else) {{$t("Dashboard.__NoExpenseData")}}
              v-col(cols="12" md="6")
                v-simple-table.report-table(v-if="costsAndExpensesTableData.length!=0" dense)
                  thead
                    tr
                      th {{$t("Dashboard.__ExpenseAccount")}}
                      th.text-right {{$t("Dashboard.__ExpenseProportion")}}
                      th.text-right {{$t("Dashboard.__ExpenseAmt")}}
                  tbody
                    tr(v-for="item in costsAndExpensesTableData") 
                      td {{getAccountTranslatedName(item.name)}}
                      td.text-right {{item.percentage.toFixed(2)}} %
                      td.text-right {{getAmountWithCurrency(item.balance, currencyCode)}}




</template>
<script>
import moment from "moment"
import BarChart from "@/components/charts/BarChart"
import PieChart from "@/components/charts/PieChart"
import * as TimeHelper from "@/utils/timeHelper"
import * as CurrencyHelper from "@/utils/currencies"
import * as accountHelper from "@/utils/accountHelper"

export default {
  mixins: [TimeHelper.mixin, CurrencyHelper.mixin, accountHelper.mixin],
  components: {
    BarChart,
    PieChart
  },
  props: ["alert"],
  data() {
    return {
      currencyCode: "",

      chartColors: {
        red: "rgb(255, 99, 132)",
        orange: "rgb(255, 159, 64)",
        yellow: "rgb(255, 205, 86)",
        green: "rgb(75, 192, 192)",
        blue: "rgb(54, 162, 235)",
        purple: "rgb(153, 102, 255)",
        grey: "rgb(201, 203, 207)"
      },
      actionItems: [
        {
          to: "/estimates/new",
          title: this.$t("EstimatesAndInvoices.__Estimate"),
          disabled: false
        },
        {
          to: "/invoices/new",
          title: this.$t("EstimatesAndInvoices.__Invoice"),
          disabled: false
        },
        {
          to: "/bills/new",
          title: this.$t("Bills.__Bill"),
          disabled: false
        },
        {
          to: "/customers/new",
          title: this.$t("Customers.__CustomerInfo"),
          disabled: false
        },
        {
          to: "/vendors/new",
          title: this.$t("Vendors.__VendorInfo"),
          disabled: false
        },
        {
          to: "/products/new",
          title: this.$t("Products.__ProductAndService"),
          disabled: false
        }
      ],
      shortcutItems: [
        {
          to: "/estimates",
          title: this.$t("Dashboard.__EstimateList"),
          disabled: false
        },
        {
          to: "/invoices#unpaid",
          title: this.$t("Dashboard.__InvoiceList"),
          disabled: false
        },
        {
          to: "/bills",
          title: this.$t("Dashboard.__BillList"),
          disabled: false
        },
        {
          to: "/settings/user-management",
          title: this.$t("Settings.__UserManagement"),
          disabled: false
        },
        {
          to: "/settings/languages",
          title: this.$t("Dashboard.__ChangeLanguage"),
          disabled: false
        }
      ],
      overdueInvoices: [],
      overdueBills: [],
      invoicesTotalArray: [],
      billsTotalArray: [],
      invoiceAndBillChartdata: {},
      invoiceAndBillOptions: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          yAxes: [
            {
              id: "y",
              type: "linear",
              position: "left",
              scaleLabel: {
                display: true,
                labelString: this.$t("Dashboard.__TotalLabel")
              }
            },
            {
              id: "y1",
              type: "linear",
              position: "right",
              ticks: {
                stepSize: 1
              },
              scaleLabel: {
                display: true,
                labelString: this.$t("Dashboard.__NumLabel")
              }
            }
          ]
        }
      },
      costsAndExpensesChartMode: "month",
      costsAndExpensesRawData: {},
      costsAndExpensesTableData: [],
      costsAndExpensesChartData: {
        labels: [],
        datasets: []
      },
      costsAndExpensesChartOptions: {
        responsive: true,
        maintainAspectRatio: false
      },
      incomeStatementsChartMode: "month12",
      incomeStatementsRawData: [],
      incomeTableRawData: [],
      incomeStatementsChartData: {
        labels: [],
        datasets: []
      },
      incomeStatementsChartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          yAxes: [
            {
              scaleLabel: {
                display: true,
                labelString: this.$t("Dashboard.__AmtLabel")
              }
            }
          ]
        }
      },
      cashFlowChartMode: "month12",
      cashFlowRawData: [],
      cashFlowChartData: {
        labels: [],
        datasets: []
      },
      cashFlowChartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          yAxes: [
            {
              scaleLabel: {
                display: true,
                labelString: this.$t("Dashboard.__AmtLabel")
              }
            }
          ]
        }
      },

      agedReceivablesData: null,
      agedPayablesData: null
    }
  },
  watch: {
    costsAndExpensesChartMode(value) {
      this.setCostsAndExpensesChartData()
    },
    incomeStatementsChartMode(value) {
      this.setIncomeStatementsChartData()
    },
    cashFlowChartMode(value) {
      this.setCashFlowChartData()
    }
  },
  methods: {
    getOverdueInvoices() {
      this.$store
        .dispatch("invoices/getInvoicesByStatus", "Expired")
        .then(
          function (response) {
            this.overdueInvoices = response.data.slice(0, 3)
          }.bind(this)
        )
        .catch(
          function (error) {
            this.$store.dispatch("global/stopLoading")
          }.bind(this)
        )
    },
    getOverdueBills() {
      this.$store
        .dispatch("bills/getBillsByStatus", "Expired")
        .then(
          function (response) {
            this.overdueBills = response.data.slice(0, 3)
          }.bind(this)
        )
        .catch(
          function (error) {
            this.$store.dispatch("global/stopLoading")
          }.bind(this)
        )
    },
    async getPast6MonthInvoicesTotal() {
      var today = new Date()
      this.invoicesTotalArray = []

      for (var i = 0; i < 6; i++) {
        var key = moment(new Date(today.getFullYear(), today.getMonth() - i, 1)).format("YYYY-MM")
        var from = moment(new Date(today.getFullYear(), today.getMonth() - i, 1)).format("YYYY-MM-DD")
        var to = moment(new Date(today.getFullYear(), today.getMonth() - i + 1, 0)).format("YYYY-MM-DD")
        var invoices = await this.getInvoicesByTimeRange(from, to, key)
        var bills = await this.getBillsByTimeRange(from, to, key)
        this.invoicesTotalArray.push(invoices)
        this.billsTotalArray.push(bills)
      }

      //Chart
      this.invoicesTotalArray.reverse()
      this.billsTotalArray.reverse()
      this.invoiceAndBillChartdata = {
        labels: this.invoicesTotalArray.map(item => item.key),
        datasets: [
          {
            label: this.$t("Dashboard.__TotalAmtOfInv"),
            backgroundColor: "#efab88",
            yAxisID: "y",
            data: this.invoicesTotalArray.map(item => item.total),
            order: 2
          },
          {
            label: this.$t("Dashboard.__NumOfInv"),
            yAxisID: "y1",
            backgroundColor: "#e67339",
            borderColor: "#e67339",
            fill: false,
            data: this.invoicesTotalArray.map(item => item.cnt),
            type: "line",
            lineTension: 0,
            // this dataset is drawn on top
            order: 1
          },
          {
            label: this.$t("Dashboard.__TotalAmtOfBill"),
            yAxisID: "y",
            backgroundColor: "#b2eded",
            data: this.billsTotalArray.map(item => item.total),
            order: 2
          },
          {
            label: this.$t("Dashboard.__NumOfBills"),
            yAxisID: "y1",
            backgroundColor: "#14c8c8",
            borderColor: "#14c8c8",
            fill: false,
            data: this.billsTotalArray.map(item => item.cnt),
            type: "line",
            lineTension: 0,
            // this dataset is drawn on top
            order: 1
          }
        ]
      }
    },
    getInvoicesByTimeRange(from, to, key) {
      return this.$store
        .dispatch("invoices/getInvoicesByTimeRange", {
          from: from,
          to: to
        })
        .then(
          function (response) {
            var total = 0
            var cnt = response.data.length
            for (var item of response.data) {
              total += item.amount
            }
            // this.$set(this.invoicesTotal, key, response.data)
            return Promise.resolve({
              key: key,
              cnt: cnt,
              total: total
            })
          }.bind(this)
        )
        .catch(
          function (error) {
            return Promise.reject(error)
          }.bind(this)
        )
    },
    getBillsByTimeRange(from, to, key) {
      return this.$store
        .dispatch("bills/getBillsByTimeRange", {
          from: from,
          to: to
        })
        .then(
          function (response) {
            var total = 0
            var cnt = response.data.length
            for (var item of response.data) {
              total += item.amount
            }
            return Promise.resolve({
              key: key,
              cnt: cnt,
              total: total
            })
          }.bind(this)
        )
        .catch(
          function (error) {
            return Promise.reject(error)
          }.bind(this)
        )
    },
    getAgedReceivables() {
      this.$store
        .dispatch("reports/getCustomerAgedReceivables", {
          date: this.getStringByFormat(new Date())
        })
        .then(
          function (response) {
            var totalDic = {
              vendorName: this.$t("Reports.__TotalUnpaid"),
              total: 0,
              overdue: 0,
              "30OrLess": {},
              "31To60": {},
              "61To90": {},
              "91OrMore": {},
              NotYetOverdue: {}
            }
            response.data.map(item => {
              var total = 0
              var overdue = 0
              for (var i of item.agedReceivables) {
                total += i.unpaid
                if (i.description != "NotYetOverdue") overdue += i.unpaid
                if (totalDic[i.description] == undefined)
                  totalDic[i.description] = {
                    amount: 0,
                    count: 0
                  }
                totalDic[i.description].amount += i.unpaid
                totalDic[i.description].count += i.count
              }
              totalDic["total"] += total
              totalDic["overdue"] += overdue
            })
            this.agedReceivablesData = totalDic

            this.$store.dispatch("global/stopLoading")
          }.bind(this)
        )
        .catch(
          function (error) {
            this.$store.dispatch("global/stopLoading")
          }.bind(this)
        )
    },
    getAgedPayables() {
      this.$store
        .dispatch("reports/getVendorAgedPayables", {
          date: this.getStringByFormat(new Date())
        })
        .then(
          function (response) {
            var totalDic = {
              vendorName: this.$t("Reports.__TotalUnpaid"),
              total: 0,
              overdue: 0,
              "30OrLess": {},
              "31To60": {},
              "61To90": {},
              "91OrMore": {},
              NotYetOverdue: {}
            }

            response.data.map(item => {
              var total = 0
              var overdue = 0
              for (var i of item.agedPayables) {
                total += i.unpaid
                if (i.description != "NotYetOverdue") overdue += i.unpaid
                if (totalDic[i.description] == undefined)
                  totalDic[i.description] = {
                    amount: 0,
                    count: 0
                  }
                totalDic[i.description].amount += i.unpaid
                totalDic[i.description].count += i.count
              }
              totalDic["total"] += total
              totalDic["overdue"] += overdue
            })
            this.agedPayablesData = totalDic

            this.$store.dispatch("global/stopLoading")
          }.bind(this)
        )
        .catch(
          function (error) {
            this.$store.dispatch("global/stopLoading")
          }.bind(this)
        )
    },
    setCostsAndExpensesChartData() {
      var colorNames = Object.keys(this.chartColors)
      this.costsAndExpensesTableData = this.costsAndExpensesRawData[this.costsAndExpensesChartMode]
      var dataset = { backgroundColor: [], data: [] }
      var labels = []

      this.costsAndExpensesTableData.forEach(
        function (d, index) {
          var colorName = colorNames[index % colorNames.length]
          dataset.backgroundColor.push(this.chartColors[colorName])
          dataset.data.push(d.balance)
          labels.push(this.getAccountTranslatedName(d.name))
        }.bind(this)
      )

      this.costsAndExpensesChartData = {
        labels: labels,
        datasets: [dataset]
      }
    },
    getCostsAndExpenses() {
      this.$store
        .dispatch("dashboard/getCostsAndExpenses")
        .then(
          function (response) {
            this.costsAndExpensesRawData = response.data
            this.setCostsAndExpensesChartData()
          }.bind(this)
        )
        .catch(
          function (error) {
            this.$store.dispatch("global/stopLoading")
          }.bind(this)
        )
    },
    setIncomeStatementsChartData() {
      var data =
        this.incomeStatementsChartMode == "month12" ? this.incomeStatementsRawData.slice(12) : this.incomeStatementsRawData

      var labels = []
      var costsBalances = []
      var expensesBalances = []
      var incomesBalances = []
      var netBalances = []
      data.forEach(
        function (d, index) {
          labels.push(d.month)
          costsBalances.push(d.costsBalance)
          expensesBalances.push(d.expensesBalance)
          incomesBalances.push(d.incomesBalance)
          netBalances.push(d.netBalance)
        }.bind(this)
      )

      this.incomeStatementsChartData = {
        labels: labels,
        datasets: [
          {
            label: this.$t("Dashboard.__Income"),
            backgroundColor: "#ea8f61",
            stack: "Stack0",
            data: incomesBalances
          },
          {
            label: this.$t("Dashboard.__Cost"),
            backgroundColor: "#64dbdb",
            stack: "Stack1",
            data: costsBalances
          },
          {
            label: this.$t("Dashboard.__Expense"),
            backgroundColor: "#88a2ed",
            stack: "Stack1",
            data: expensesBalances
          }
          // {
          //     label: this.$t("Dashboard.__NetIncome"),
          //     backgroundColor: "#505356",
          //     borderColor: "#505356",
          //     type: "line",
          //     fill: false,
          //     order: 1,
          //     lineTension: 0,
          //     data: netBalances
          // }
        ]
      }
    },
    getIncomes() {
      this.$store
        .dispatch("dashboard/getIncomes")
        .then(
          function (response) {
            this.incomeStatementsRawData = response.data.month
            this.incomeTableRawData = response.data.year.reverse()
            this.setIncomeStatementsChartData()
          }.bind(this)
        )
        .catch(
          function (error) {
            this.$store.dispatch("global/stopLoading")
          }.bind(this)
        )
    },
    setCashFlowChartData() {
      var data = this.cashFlowChartMode == "month12" ? this.cashFlowRawData.slice(12) : this.cashFlowRawData

      var labels = []
      var cashInflows = []
      var cashOutflows = []
      var netCashChanges = []
      data.forEach(
        function (d, index) {
          labels.push(d.month)
          cashInflows.push(d.cashInflow)
          cashOutflows.push(-d.cashOutflow)
          netCashChanges.push(d.netCashChange)
        }.bind(this)
      )

      this.cashFlowChartData = {
        labels: labels,
        datasets: [
          {
            label: this.$t("Dashboard.__CashInflow"),
            backgroundColor: "#ea8f61",
            data: cashInflows,
            stack: "Stack 0",
            order: 2
          },
          {
            label: this.$t("Dashboard.__CashOutflow"),
            backgroundColor: "#b2eded",
            data: cashOutflows,
            stack: "Stack 0",
            order: 2
          },
          {
            label: this.$t("Dashboard.__NetChange"),
            backgroundColor: "#505356",
            borderColor: "#505356",
            type: "line",
            fill: false,
            order: 1,
            lineTension: 0,
            data: netCashChanges
          }
        ]
      }
    },
    getCashFlow() {
      this.$store
        .dispatch("dashboard/getCashFlow")
        .then(
          function (response) {
            this.cashFlowRawData = response.data.month
            this.setCashFlowChartData()
          }.bind(this)
        )
        .catch(
          function (error) {
            this.$store.dispatch("global/stopLoading")
          }.bind(this)
        )
    },
    getPassRangeDate(monthNum) {
      var date = new Date()
      date.setMonth(date.getMonth() - monthNum + 1)
      var year = date.getFullYear()
      var month = date.getMonth() + 1

      return {
        from: year + "-" + month.toString().padStart(2, "0") + "-01",
        to: this.getStringByFormat(new Date())
      }
    }
  },
  mounted() {
    if (this.alert) {
      this.$store.dispatch("global/showAlert", this.alert)
    }
  },

  created() {
    this.getOverdueInvoices()
    this.getOverdueBills()
    this.getPast6MonthInvoicesTotal()

    this.currencyCode = this.$store.getters["bizes/currencyCode"]()

    this.getAgedReceivables()
    this.getAgedPayables()

    this.getCostsAndExpenses()
    this.getIncomes()
    this.getCashFlow()
  }
}
</script>
